import { Component, HostListener, OnInit, OnDestroy, ElementRef, Input, ViewChild, ViewChildren } from '@angular/core';
import { UntypedFormControl, NgForm, FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import ArrayStore from 'devextreme/data/array_store';
import DataSource from 'devextreme/data/data_source';
import { Select as Dropdown } from 'primeng/select';
import { Observable, Subscription, of, timer, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { NewsAlertProperties, NotificationProperties } from '../Models/CmsContactUsProperties';
import { ChildAgeProps, FlightSearchAirlineCodes, FlightSearchBaseData, FlightSearchAirports, FlightSearchDestinationProperties, FlightSearchHistory, FlightSearchProperties, InfantAgeProps, FlightSearchRights, PassengerSelectionList, PassengerSelectionListInfant } from '../Models/FlightSearchProperties';
import { ImportPNREntryProprties, ImportRequest } from '../Models/ImportPnrProperties';
import { FlightSearchService } from '../Services/FlightSearch.service';
import { CMSService } from '../Services/cms.service';
import { AutoComplete } from 'primeng/autocomplete';
import { Supplier_OficeID } from '../Models/RevenueManagementProperties';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { environment } from '../../environments/environment';
import { GroupTicketProperties, GroupTicketSearchParameters } from '../Models/GroupTicketProperties';
import { GroupTicketService } from '../Services/groupTicket.service';
import { GroupTicketShowRightCMS } from '../Models/CmsLoginDealsProperties';
import { ChangeDetectorRef } from '@angular/core';
import { QueryList } from '@angular/core';
import { BsDatepickerConfig, BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { MessageService, PrimeTemplate, SharedModule } from 'primeng/api';
import { DatePicker as Calendar } from 'primeng/datepicker';
import { OfflineRequestTypeEnum, OfflineTypesMainEnum } from '../offline-new/offlineNewProperties';
import { UsersService } from '../Services/users.service';
/*import { DatePipe } from '@angular/common'*/
/*import { format } from 'date-fns';*/

import { OfflineToOnlineProperties, TicketDataRequest, TicketPnrRights } from '../Models/TicketIssuanceProperties';
import { TicketIssuanceService } from '../Services/ticketIssuance.service';
import { MobileDatepickerService } from '../Services/mobile-datepicker.service';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { Bind } from 'primeng/bind';
import { Toast } from 'primeng/toast';
import { NgClass, AsyncPipe, DatePipe } from '@angular/common';
import { MultiSelect } from 'primeng/multiselect';
import { Dialog } from 'primeng/dialog';
import { DxPopoverModule, DxHtmlEditorModule } from 'devextreme-angular';
import { DxoAnimationModule, DxoShowModule, DxoHideModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
import { Button } from 'primeng/button';
import { NgSelectModule } from '@ng-select/ng-select';
@Component({
    selector: 'app-flight-search-new1',
    templateUrl: './flight-search-new1.component.html',
    styleUrls: ['./flight-search-new1.component.css'],
    providers: [BsDatepickerConfig, BsDaterangepickerConfig],
    animations: [
        trigger('sectionAnimation', [
            state('hidden', style({
                height: '0px',
                opacity: 0,
                display: 'none'
            })),
            state('visible', style({
                height: '*',
                opacity: 1,
                display: 'flex'
            })),
            transition('hidden <=> visible', [
                animate('500ms ease-in-out')
            ])
        ])
    ],
    imports: [NavMenuComponent, Bind, Toast, FormsModule, NgClass, AutoComplete, PrimeTemplate, Calendar, Dropdown, MultiSelect, Dialog, DxPopoverModule, DxoAnimationModule, DxoShowModule, DxoHideModule, DxTemplateModule, SharedModule, Button, NgSelectModule, DxHtmlEditorModule, AsyncPipe, DatePipe]
})
export class FlightSearchNew1Component implements OnInit, OnDestroy {

  @ViewChild('returnDateId') returnDateId!: Calendar;
  @ViewChildren('departureDateId') departureDateId!: QueryList<Calendar>;


  // Constructor
  constructor(
    private ticketIssuanceService: TicketIssuanceService,
    private flightService: FlightSearchService,
    private router: Router,
    public cmsService: CMSService,
    private modalService: NgbModal,
    private ticketService: GroupTicketService,
    private cdr: ChangeDetectorRef,
    private messageService: MessageService,
    private userService: UsersService,
    public mobileDatepicker: MobileDatepickerService
  ) {
    this.minDateRange = new Date();
    this.maxDateRange = new Date();
    this.minDateRange.setDate(this.minDateRange.getDate() + 0);
    this.maxDateRange.setDate(this.maxDateRange.getDate() + 365);
  }
  // Subscriptions
  timerSubscription: Subscription;
  currentDateDepartureList: Date[] = [];
  currentDateDeparture!: string;
  currentDateReturn!: Date;


  // Observables
  pccList$: Observable<Supplier_OficeID[]>;
  position: string = 'top';
  // Data Sources
  dataSource: any;
  airportList: FlightSearchAirports[] = [];
  airlineList$: FlightSearchAirlineCodes[] = [];
  allBaseData$: FlightSearchBaseData;
  importPnrEntryList$: ImportPNREntryProprties[];

  // Form Controls
  selected = new UntypedFormControl(0);
  airportDATAList: FlightSearchAirports[] = [];
  city: string = "";
  // View Children
  @ViewChildren('focusable1') searchFlightFrom: QueryList<AutoComplete>;
  @ViewChildren('focusable') searchFlightTo: QueryList<AutoComplete>;
  @ViewChild('focusable') autoComplete1: AutoComplete;
  @ViewChild('focusable1') autoComplete: AutoComplete;
  @ViewChild('dropdown') dropdown !: Dropdown;
  @ViewChild('tbRoundTripDeparting') tbRoundTripDepartingDate !: ElementRef<HTMLInputElement>;

  // Input Properties
  @Input() headerText: string = "Select Airline";

  // State Variables
  isPakistan: boolean = false;
  isAG01: boolean = false;
  isOneway: boolean = true;
  isRoundtrip: boolean = false;
  isMulticity: boolean = false;
  oneWayResults: boolean = false;
  roundTripResults: boolean = false;
  multicityResults: boolean = false;
  dataFormSubmitoneway: boolean = false;
  isSectionVisible = false;
  primeShowModal: boolean = false;
  Adulttravlers: boolean = false;
  AllTravelers: boolean = false;
  searchHistory = false;
  activeTab: string = 'home';
  selectedDiv: number | null = null;
  selectedMainDiv: number | null = null;
  flightSearch: number = 1; // Default selection for Search Flights
  bookingOffline: number = 0;
  importPnr: number = 0;
  groupTicket: number = 0;
  visible: boolean = false;

  // Popup/Dropdown Toggles
  popoverArray: boolean[] = [];
  displayChildPopup: boolean = false;
  displayInfantPopup: boolean = false;
  isTravelerPopupVisible = false;
  selectAirLine = false;
  showCard: boolean = true;
  selectedDropdown: boolean = false;
  adultDropdowndiv: boolean = false;
  childpopUp: boolean = false;

  // Dates
  date: Date | undefined;
  date1: Date;
  date2: Date;
  minDateRange: Date;
  maxDateRange: Date;
  minDate: Date;
  maxDate = new Date();


  // Date Configurations
  get monthsToShow(): number {
    return this.mobileDatepicker.monthsToShow;
  }
  dateCalenderShow: number = 3;
  get isMobile(): boolean {
    return this.mobileDatepicker.isMobile;
  }

  // Traveler Configuration
  passengerSelectionList: PassengerSelectionList[] = [];
  passengerSelectionListInfant: PassengerSelectionListInfant[] = [];
  childAgeProvided: boolean = false;
  infantAgeProvided: boolean = false;
  selectedChild!: string;
  selectedInfant!: string;
  multiCityDeparture: string = "";
  multiwayFrom: string = "";
  // Flight Search Properties
  searchObj = new FlightSearchProperties();
  flightSearchRightsObj = new FlightSearchRights();
  groupTicketSearch = new GroupTicketSearchParameters();
  groupTicketList: GroupTicketProperties[] = [];
  groupTicketShowRightCMS = new GroupTicketShowRightCMS();
  searchHistoryList: FlightSearchHistory[] = [];
  airLineData: FlightSearchAirlineCodes[] = [];
  onewayOrigin: string = "";
  onewayDestination: string = "";

  // Import Request
  importPNR = new ImportRequest();
  supplierId: string = "SPB_001";

  // Validation Flags
  onewayvalidationerquired: boolean = false;
  roundvalidationerquired: boolean = false;
  multicityvalidationerquired: boolean = false;
  IMPORTRights: boolean = false;
  // Airport Data
  airportData: string[] = [];
  datess = [];
  airportFromList: any;
  airportToList: any;
  idAssigned: boolean = false;
  dialogVisible: boolean = false;
  airportName: string = "";
  filteredAirports: string[] = [];
  // Modal Options
  closeResult = '';
  modalOptions: NgbModalOptions;
  groupObj!: any | Object;
  groupedAirports: any[] = [];
  filteredAirportsOW: string[] = [];
  selectedAirportOW: FlightSearchAirports = new FlightSearchAirports();
  airP: any[] = [];
  internationalCity: string = "";
  // Journey Type
  journeytype: number = 0;


  haveRights: boolean;
  selectedFairType: string;
  selectedEconomy: string;
  navMenu: any = null;
  rows: { id: string, index: number }[] = [];
  serializedDate = new UntypedFormControl(new Date().toISOString());
  isDivVisible = false;
  economy: string;
  economydropdown = [
    { model: "Economy", color: "red" },
    { model: "Premium Economy", color: "white" },
    { model: "Business", color: "black" },
    { model: "First", color: "black" }
  ];

  EconomyDropdown = [
    { model: "Economy", color: "red" },
    { model: "Premium Economy", color: "white" },
    { model: "Business", color: "black" },
    { model: "First", color: "black" }
  ];


  FairTypeDropdown = [
    { model: "Low Fares", color: "red" },
    { model: "Refundable", color: "white" },
    { model: "Non-Refundable", color: "black" }

  ];

  timeList = [
    { time: "Any" },
    { time: "Morning" },
    { time: "Afternoon" },
    { time: "Night" },
    { time: "Midnight" },
  ];

  adultList = [
    { adultItem: 1 },
    { adultItem: 2 },
    { adultItem: 3 },
    { adultItem: 4 },
    { adultItem: 5 },
    { adultItem: 6 },
    { adultItem: 7 },
    { adultItem: 8 },
    { adultItem: 9 },
  ];



  childAgeList = [
    { childAgeItem: "2" },
    { childAgeItem: "3" },
    { childAgeItem: "4" },
    { childAgeItem: "5" },
    { childAgeItem: "6" },
    { childAgeItem: "7" },
    { childAgeItem: "8" },
    { childAgeItem: "9" },
    { childAgeItem: "10" },
    { childAgeItem: "11" }
  ];
  infantAgeList = [
    { infantAgeItem: "less than 1" },
    { infantAgeItem: "1" }
  ];
  roundwayDuration: number;

  cabinClassList = [
    { cabinItem: "Economy" },
    { cabinItem: "Business" },
    { cabinItem: "First" },
    /*{ cabinItem: "PremiumEconomy" },*/
  ];

  fareTypeList = [
    { fareItem: "Low Fares" },
    { fareItem: "Refundable" },
    { fareItem: "Non-Refundable" },
  ];
  tktPnrRight = new TicketPnrRights();
  loadrights() {
    ////////////////////////////////////////
    this.ticketIssuanceService.CheckTktPnrRightsAgainstAgencyAndUserId(localStorage.getItem("AgencyId"), localStorage.getItem("UserId")).subscribe((data2) => {
      this.tktPnrRight = data2;
    })
  }

  // Methods
  toggleWithAnimationOptions(index: number) {
    this.popoverArray[index] = !this.popoverArray[index];
  }

  showDialog() {
    this.visible = true;
    this.dialogVisible = true;
  }

  
  ngOnInit() {
    this.loadrights();
    this.SetCurrentDate();
    this.currentDateDepartureList.push(new Date(this.currentDateDeparture));
    this.initializeEnvironmentSettings();
    this.initializeTimer();
    this.initializeDates();
    this.initializePassengerLists();
    this.notiPop();
  
    this.GetSearchBaseData();
    this.getActiveNews();
    this.getFlightSearchHistory();
    this.showtoggleflighttypeDiv(1);
    this.GetAllGroupTicket();
    this.userService.GetUsersNavMenu(localStorage.getItem('AgencyId'), localStorage.getItem('UserId')).subscribe((data) => {
      //////console.log (data);
      this.navMenu = data;

    });
  }

  private initializeEnvironmentSettings(): void {
    this.isPakistan = environment.isPakistan;
    this.isAG01 = localStorage.getItem("ImmediateParent") === "AG01";
  }

  private initializeTimer(): void {
    this.timerSubscription = timer(0, 1800000).pipe(
      map(() => {
        this.getActiveNews();
        this.getFlightSearchHistory();
      })
    ).subscribe();
  }

  private initializeDates(): void {
    const today = new Date();
    const month = today.getMonth();
    const year = today.getFullYear();
    const prevMonth = month === 0 ? 11 : month - 1;
    const prevYear = prevMonth === 11 ? year - 1 : year;

    this.minDate = new Date();
    this.minDate.setMonth(prevMonth);
    this.minDate.setFullYear(prevYear);

   // console.log(this.searchObj);
  }

  private initializePassengerLists(): void {
    this.Adulttravlers = true;
    this.selectedMainDiv = 1;
    this.childpopUp = true;

    this.passengerSelectionList = [
      { paxId: 2, label: 'Child', labelText: ' (2y to 12y)', value: 0, min: 0, max: 8 }
    ];

    this.passengerSelectionListInfant = [
      { paxId: 3, labelInf: 'Infant', labelTextInf: ' (Younger than 2y)', valueInf: 0, minInf: 0, maxInf: 1 }
    ];
  }


  ClosePaxDropdown = (): void => {
    if (this.dropdown) {
      setTimeout(() => {
        this.dropdown.overlayVisible = false;
      }, 0);
    }
  }
  TotalNumberPassengers(): number {
    return this.passengerSelectionList.reduce((total, pax) => total + pax.value, 0);
  }
  TotalNumberPassengersInfant(): number {
    return this.passengerSelectionListInfant.reduce((total, paxId) => total + paxId.valueInf, 0);
  }
  UpdateSelectedPassenger = (): void => {
    this.selectedChild = this.TotalNumberPassengers() > 0 ? `${this.TotalNumberPassengers()} Child` : '';

  }
  UpdateSelectedPassengerInfant = (): void => {
    this.selectedInfant = this.TotalNumberPassengersInfant() > 0 ? `${this.TotalNumberPassengersInfant()} Infant` : '';

  }
  UpdateMaxValues(): void {
    const adults = this.passengerSelectionList.find(pax => pax.paxId === 1);
    const children = this.passengerSelectionList.find(pax => pax.paxId === 2);
    const infants = this.passengerSelectionList.find(pax => pax.paxId === 3);

    if (adults && children && infants) {
      const totalPassengers: number = this.TotalNumberPassengers();
      const totalPassengersInf: number = this.TotalNumberPassengersInfant();
      adults.max = Math.min(9, 9 - (children.value + infants.value));
      children.max = Math.min(9, 9 - (adults.value + infants.value));
      infants.max = adults.value;
   
      if (totalPassengers >= 9) {
        adults.max = adults.value;
        children.max = children.value;
     
      }
      if (totalPassengersInf >= 9) {
        infants.max = infants.value;
      }
    }
  }
  changeAdult() {
    if ((this.searchObj.adult + this.searchObj.child) > 9) {

      this.initializePassengerLists();
      this.UpdateSelectedPassenger();
      this.UpdateMaxValues();
      this.searchObj.child = 0;
      this.searchObj.infant = 0;
      this.searchObj.childAges = [];
      this.searchObj.infantAges = [];
    }
    if (this.searchObj.adult < this.searchObj.infant) {

      this.UpdateSelectedPassengerInfant();
      this.UpdateMaxValues();
      this.searchObj.infant = 0;
      this.searchObj.infantAges.length = 0;
    }
  }
  IncrementPax = (item: PassengerSelectionList): void => {
    const totalPassengers: number = this.TotalNumberPassengers();
    if (item.value < item.max && totalPassengers < 9) {
      
      
      if (item.paxId === 2) {
        if (this.searchObj.adult + this.searchObj.child > 9) {
          this.searchObj.childAges.length = 0;
        }
        else {
          let countc = this.searchObj.adult + this.searchObj.child;
          if (countc < 9) {
            item.value++;
            this.UpdateSelectedPassenger();
            this.UpdateMaxValues();
            this.searchObj.child = item.value;
            this.searchObj.childAges.push("2")
          }
          
        }
       
      }
      else if (item.paxId === 3) {
        if (this.searchObj.infant < this.searchObj.adult) {
          item.value++;
          this.searchObj.infant = item.value;
          this.searchObj.infantAges.push("less than 1")
        }

      }
    }
  };
  IncrementPaxInf = (item: PassengerSelectionListInfant): void => {
    const totalPassengers: number = this.TotalNumberPassengersInfant();
    if (this.searchObj.infant < this.searchObj.adult) {
      item.valueInf++;
      this.UpdateSelectedPassengerInfant();
      this.UpdateMaxValues();
      this.searchObj.infant = item.valueInf;
      this.searchObj.infantAges.push("less than 1")
    }  };
  DecrementPax = (item: PassengerSelectionList): void => {
    if (item.value > item.min) {
      item.value--;
      this.UpdateSelectedPassenger();

      if (item.paxId === 1) {
        this.searchObj.adult = item.value;
        const infants = this.passengerSelectionList.find(pax => pax.paxId === 3);
        if (infants && infants.value > item.value) {
          infants.value = item.value;
          this.searchObj.infant = infants.value;
          this.UpdateSelectedPassenger();
        }
      }
      if (item.paxId === 2) {
        this.searchObj.child = item.value;
        this.searchObj.childAges.pop()

      }
      if (item.paxId === 3) {
        this.searchObj.infant = item.value;
        this.searchObj.infantAges.pop()
      }
      this.UpdateMaxValues();
    }
  };
  DecrementPaxInf = (item: PassengerSelectionListInfant): void => {
    if (item.valueInf > item.minInf) {
      item.valueInf--;
      this.UpdateSelectedPassengerInfant();

      if (item.paxId === 1) {
        this.searchObj.adult = item.valueInf;
        const infants = this.passengerSelectionList.find(pax => pax.paxId === 3);
        if (infants && infants.value > item.valueInf) {
          infants.value = item.valueInf;
          this.searchObj.infant = infants.value;
          this.UpdateSelectedPassengerInfant();
        }
      }
      if (item.paxId === 2) {
        this.searchObj.child = item.valueInf;
        this.searchObj.childAges.pop()

      }
      if (item.paxId === 3) {
        this.searchObj.infant = item.valueInf;
        this.searchObj.infantAges.pop()
      }
      this.UpdateMaxValues();
    }
  };

  //Child Field end



 

  ngAfterViewInit() {
   
    setTimeout(() => {
      const inputElement = this.autoComplete.inputEL.nativeElement;
      if (inputElement) {
        inputElement.focus();
      }
    }, 0);
  }


  AddNewFlight() {
    this.dataFormSubmitoneway = false;
    if (this.searchObj.flightLocationInfo.length < 7) {
      let flight = new FlightSearchDestinationProperties();
      this.searchObj.flightLocationInfo.push(flight);
    }
   
  }


  RemoveFlight(i: any) {
    if (i !== -1) {
      this.searchObj.flightLocationInfo.splice(i, 1);
    }
  
  }
  



  searchFlightsMethod(divNumber: number):void {
    this.selectedMainDiv = divNumber;
  }
 


  GroupTicketForUser() {

   
    this.router.navigateByUrl('/groupTicketForUserNew');

  }


  GetAllGroupTicket = (): void => {
    this.ticketService.GetAllGroupTicket(this.groupTicketSearch).subscribe(
      response => {
       // console.log(response)
        if (response.status) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const agencyId = localStorage.getItem("AgencyId");

          // Fetch the group ticketShowRight
          this.flightService.GetAgencyAndUserGroupTicketRigts(localStorage.getItem("UserId"), localStorage.getItem("AgencyId"))
            .subscribe(data => {
              this.flightSearchRightsObj = data;
              localStorage.setItem("flightSearchRightsObj", JSON.stringify(this.flightSearchRightsObj));
              // console.log(this.flightSearchRightsObj)

              const groupTicketViewRight = this.flightSearchRightsObj.agencyGroupTicketSearch && this.flightSearchRightsObj.userGroupTicketSearch;


              // Process the tickets after fetching the agency details
              this.groupTicketList = response.responseData.filter(ticket => {

                const ticketExpirationDate = new Date(ticket.ticketExpiryDate);
                ticketExpirationDate.setHours(0, 0, 0, 0);

                const isNotExpired = ticketExpirationDate >= today;
               // console.log(isNotExpired, groupTicketViewRight)
                return isNotExpired && groupTicketViewRight; // Adjust the right check as needed
              })
                .map(ticket => ({
                  ...ticket,
                  tripRoute: `${ticket.onewayFromAirport}--${ticket.onewayToAirport}`
                }));

             // console.log(this.groupTicketList);
            },
              error => {
              //  console.error('Error fetching agency details:', error);
              }
            );
        }
      },
      error => {
        console.error('Error fetching group tickets:', error);
      }
    );
  }

  GroupTicketClick = (index: number): void => {
    this.searchObj.byPassSearch = true;

    this.searchObj.agencyID = localStorage.getItem("AgencyId")
    this.searchObj.tripType = "single-round";
    this.searchObj.fareOnCall = this.groupTicketList[index].fareOnCall;
    if (this.groupTicketList[index].isAdult) {
      this.searchObj.adult = 1;
    }
    if (this.groupTicketList[index].isChild) {
      this.searchObj.child = 1;
    }
    if (this.groupTicketList[index].isInfant) {
      this.searchObj.infant = 1;
    }
    let flightSearch = new FlightSearchDestinationProperties();
    this.searchObj.flightLocationInfo = [];
    this.searchObj.flightLocationInfo.push(flightSearch);
    this.searchObj.flightLocationInfo[0].departureDate = String(this.groupTicketList[index].departureDate).split("T")[0];
    this.searchObj.flightLocationInfo[0].fromCity = this.groupTicketList[index].onewayFromAirport;
    this.searchObj.flightLocationInfo[0].toCity = this.groupTicketList[index].onewayToAirport;
    let flightSearchs = new FlightSearchDestinationProperties();
    if (this.groupTicketList[index].returnFromAirport != "") {
      this.searchObj.flightLocationInfo.push(flightSearchs);
      this.searchObj.flightLocationInfo[1].departureDate = String(this.groupTicketList[index].returnDate).split("T")[0];
      this.searchObj.returnDate = this.searchObj.flightLocationInfo[1].departureDate;
      this.searchObj.flightLocationInfo[1].fromCity = this.groupTicketList[index].returnFromAirport;
      this.searchObj.flightLocationInfo[1].toCity = this.groupTicketList[index].returnToAirport;
      this.searchObj.journeyType = 2;
    }
    else {
      this.searchObj.journeyType = 1;
    }
    const fromAirport = this.airportList.find(air => air.iatA_CODE === this.searchObj.flightLocationInfo[0].fromCity)
    this.searchObj.flightLocationInfo[0].fromAirport = fromAirport.airportName;
    const toAirport = this.airportList.find(air => air.iatA_CODE === this.searchObj.flightLocationInfo[0].toCity)
    this.searchObj.flightLocationInfo[0].toAirport = toAirport.airportName;
    localStorage.setItem('flightSearchData', JSON.stringify(this.searchObj));
    this.router.navigateByUrl('/flightResults');

  }



  SearchHistory() {
    this.searchHistory = !this.searchHistory;
    this.showDialog();
  }
  closeSearchHistory() {
    this.searchHistory = !this.searchHistory
  }

  finalcountofpassengers: number = 1;
  toggleSectionVisibility() {
   
    this.isSectionVisible = !this.isSectionVisible;
  }




  showtoggleflighttypeDiv(divNumber: number): void {

    let flightlocate = FlightSearchDestinationProperties[0];
    flightlocate = JSON.parse(JSON.stringify(this.searchObj.flightLocationInfo));
    this.selectedDiv = divNumber;
    if (this.searchObj.journeyType == divNumber) {
      return;
    }

    this.searchObj.flightLocationInfo = [];
    this.searchObj.cabinClass = "Economy";
    if (divNumber == 1) {

      let flight = new FlightSearchDestinationProperties();
      

      this.searchObj.flightLocationInfo.push(flight);
      this.searchObj.journeyType = 1;


    }
    else if (divNumber == 2) {

      let flight = new FlightSearchDestinationProperties();
      this.searchObj.flightLocationInfo.push(flight);
      this.searchObj.journeyType = 2;

    }
    else if (divNumber == 3) {
      let flight = new FlightSearchDestinationProperties();
      this.searchObj.flightLocationInfo.push(flight);
      let flights = new FlightSearchDestinationProperties();
      this.searchObj.flightLocationInfo.push(flights);
      this.searchObj.journeyType = 3;

    }

    if (flightlocate != null && flightlocate.length > 0) {
      this.searchObj.flightLocationInfo[0].fromAirport = flightlocate[0].fromAirport;
      this.searchObj.flightLocationInfo[0].toAirport = flightlocate[0].toAirport;
    }
  }

  filterAirports(event: any) {
    let filtered: string[] = [];
    let query = event.query.toLowerCase();
    for (let i = 0; i < this.airportList.length; i++) {
      let airport = this.airportList[i];
      if (airport.iatA_CODE.toLowerCase().startsWith(query) || airport.city.toLowerCase().startsWith(query)) {
        if (airport.iatA_CODE.toLowerCase() === query) {
          filtered[0] = airport.airportName;
        }
        filtered.push(airport.airportName);
      }
    }
    filtered = [...new Set(filtered)];
    this.filteredAirports = filtered;
  }

  InvertSearchFromTo = (index: number): void => {
    const cityFromTo: FlightSearchDestinationProperties = this.searchObj.flightLocationInfo[index];
    const { fromAirport, fromCity, toAirport, toCity } = cityFromTo;
    cityFromTo.fromAirport = toAirport;
    cityFromTo.fromCity = toCity;
    cityFromTo.toAirport = fromAirport;
    cityFromTo.toCity = fromCity;
  }

  

  filterAirportsOW(event: any) {


    let filteredOW: string[] = [];

    let query = event.query.toLowerCase();
    for (let i = 0; i < this.airportList.length; i++) {
      let airportOW = this.airportList[i];
      if (airportOW.iatA_CODE.toLowerCase().startsWith(query) || airportOW.city.toLowerCase().startsWith(query)) {
        if (airportOW.iatA_CODE.toLowerCase() === query) {
          filteredOW[0] = airportOW.airportName;
        }
        filteredOW.push(airportOW.airportName);
      }

    }
    filteredOW = [...new Set(filteredOW)];
    this.filteredAirportsOW = filteredOW;
    //console.log(this.filteredAirportsOW)

  }

 

  ClickSearchFromAirport = (index: number): void => {
    this.searchObj.flightLocationInfo[index].fromCity = '';
    this.searchObj.flightLocationInfo[index].fromAirport = '';
   setTimeout(() => {
     const inputElement = this.searchFlightFrom.toArray()[index];

      if (inputElement) {
        //console.log(inputElement.focus())
        inputElement.inputEL.nativeElement.focus();

      }

    }, 0);

  }
  ClickSearchToAirport = (index: number): void => {
    this.searchObj.flightLocationInfo[index].toCity = '';
    this.searchObj.flightLocationInfo[index].toAirport = '';
    setTimeout(() => {
      const autocomplete = this.searchFlightTo.toArray()[index];
      if (autocomplete) {
        autocomplete.inputEL!.nativeElement.focus()
      }
    }, 0);

  }
  SearchFlightToCity = (toAirport: string, index: number): void => {
    if (toAirport != undefined && toAirport != null && toAirport != "") {
      this.searchObj.flightLocationInfo[index].toCity = toAirport.split("-")[0].trim();
    }
  }
  SearchFlightFromCity = (fromAirport: string, index: number): void => {

    if (fromAirport != undefined && fromAirport != null && fromAirport != "") {
      this.searchObj.flightLocationInfo[index].fromCity = fromAirport.split("-")[0].trim();
    }

  }



  /******************** Notification POP UP ****************************************/
  activeNotification: NotificationProperties[] = [];
  getActiveNotification() {
    this.cmsService.getActiveNotification().subscribe((data) => {
      this.activeNotification = data;
    })
  }

  /******************** News ****************************************/
  activeNews: NewsAlertProperties[] = [];
  getActiveNews() {
    this.cmsService.getActiveNews().subscribe((data) => {
      this.activeNews = data;
    })
  }

  notiPop() {
 

    if (this.isAG01) {
      this.cmsService.getActiveNotification().subscribe((data) => {

        this.activeNotification = data;
        this.primeShowModal = true;
      });
    }
    this.cmsService.GetGroupTicketRight().subscribe(data => {
      this.groupTicketShowRightCMS = data;

    })
  }
  
  

  GetSearchBaseData() {
    try {
      this.flightService.CheckFlightSearchScreenRights(localStorage.getItem("UserId"), localStorage.getItem("AgencyId")).subscribe((data1) => {
        this.haveRights = data1;
        this.flightService.GetFlightBaseData().subscribe((data) => {
          this.allBaseData$ = data;
          //this.originalAirlines = this.allBaseData$.airlines;
          this.airlineList$ = this.allBaseData$.airlines;


          this.airLineData = this.allBaseData$.airlines;
          this.airportList = this.allBaseData$.airports;


          this.flightService.GetAllImportPnrEntry().subscribe((oficeIdData) => {
            this.importPnrEntryList$ = oficeIdData;
          });
          this.flightService.GetGetAllBookingPCCs(this.supplierId).subscribe((oficeIdData) => {
            this.pccList$ = of(oficeIdData);
          });

          this.dataSource = new DataSource({
            store: new ArrayStore({
              data: this.airportList,
              key: "airportName"
            }),
            group: "cityCountry",


          });


          this.flightService.CheckImportRights(localStorage.getItem("UserId"), localStorage.getItem("AgencyId")).subscribe((data2) => {
            this.IMPORTRights = data2;
          })
          this.dataSource.load();


          //}
        })
      })
    }
    catch (e) {

    }
  }




  addDaysReturn() {
    try {
      if (this.searchObj.flightLocationInfo[0].departureDateFront) {
        let departureDate = new Date(this.searchObj.flightLocationInfo[0].departureDateFront);
        // Add the days
        departureDate.setDate(departureDate.getDate() + this.searchObj.days);
        this.searchObj.returnDateFront = departureDate;
      }
    }
    catch (e) {
      //console.log(e);
    }
  }

  returndatechange() {
    try {
      if (this.searchObj.returnDateFront && this.searchObj.flightLocationInfo && this.searchObj.flightLocationInfo[0]?.departureDateFront) {
        const depDate = new Date(this.searchObj.flightLocationInfo[0].departureDateFront);
        const retDate = new Date(this.searchObj.returnDateFront);
        depDate.setHours(0, 0, 0, 0);
        retDate.setHours(0, 0, 0, 0);
        const diffMs = retDate.getTime() - depDate.getTime();
        const diffDays = Math.round(diffMs / (1000 * 60 * 60 * 24));
        this.searchObj.days = diffDays >= 0 ? diffDays : 0;
      }
      if (typeof document !== 'undefined') {
        document.body.classList.remove('p-overflow-hidden');
        document.body.style.removeProperty('--scrollbar-width');
      }
    } catch (e) {
      // console.log(e);
    }
  }

 


  submitFlightSearch: boolean = false;
  preferedAirlines: string[] = [];
  flightSearchValidation(flightSearchForm: any) {
    if (!this.haveRights) {
      this.messageService.add({ severity: 'error', summary: 'Reject', detail: "You don't have right!" });
      return;
    }
    this.submitFlightSearch = true;
    if (flightSearchForm.invalid) {
      return;
    }
    else {
      for (let i = 0; i < this.searchObj.flightLocationInfo.length; i++) {
        if (this.searchObj.flightLocationInfo[i].fromAirport.split('-')[0] == this.searchObj.flightLocationInfo[i].toAirport.split('-')[0]) {
          return false;
        }
        
      }


    }

   
    for (let u = 0; u < this.preferedAirlines.length; u++) {
      if (u == 0) {
        this.searchObj.prefferedAirline1 = this.preferedAirlines[u];
      }
      if (u == 1) {
        this.searchObj.prefferedAirline2 = this.preferedAirlines[u];
      }
      if (u == 2) {
        this.searchObj.prefferedAirline3 = this.preferedAirlines[u];
      }
    }
    if (this.preferedAirlines.length > 0) {
      this.searchObj.prefferedAirlineCheck = true;
    }
    if (this.selectedDiv === 1) {
     // console.log(this.searchObj);
      this.searchObj.tripType = "single-round";
      this.OnewaySearchClick();
    }
    if (this.selectedDiv === 2) {
     // console.log(this.searchObj);
      this.searchObj.tripType = "single-round";
      this.RoundtripSearchClick();
    }
    if (this.selectedDiv === 3) {
      this.searchObj.tripType = "multi";
      for (let i: number = 1; i < this.searchObj.flightLocationInfo.length; i++) {
        if (this.searchObj.flightLocationInfo[i].departureDateFront < this.searchObj.flightLocationInfo[i - 1].departureDateFront) {
          return;
        }
      }
      this.MultiCitySearchClick();
    }

  }



  OnewaySearchClick() {
    if (this.haveRights) {
      //this.searchObj = new FlightSearchProperties();
      this.searchObj.agencyID = String(localStorage.getItem("AgencyId"));
      this.searchObj.parentHierarchy = localStorage.getItem("ParentHierarchy");
      let deplist = this.searchObj.flightLocationInfo[0].fromAirport.split("-");
      let start = deplist[0];
      let tolist = this.searchObj.flightLocationInfo[0].toAirport.split("-");
      let start1 = tolist[0];
      this.searchObj.flightLocationInfo[0].fromCity = start.trim();
      this.searchObj.flightLocationInfo[0].toCity = start1.trim();
      this.searchObj.adult = this.searchObj.adult;
      this.searchObj.infant = this.searchObj.infant;
      this.searchObj.child = this.searchObj.child;
      for (let i = 0; i < this.airportList.length; i++) {
        if (this.searchObj.flightLocationInfo[0].fromCity.trim() == this.airportList[i].iatA_CODE) {
          this.searchObj.flightLocationInfo[0].combineAirportFrom = this.airportList[i].combineAirportFrom;
          break;
        }
      }
      for (let i = 0; i < this.airportList.length; i++) {
        if (this.searchObj.flightLocationInfo[0].toCity.trim() == this.airportList[i].iatA_CODE) {
          this.searchObj.flightLocationInfo[0].combineAirportTo = this.airportList[i].combineAirportTo;
          break;
        }
      }

      for (let q = 0; q < this.searchObj.infantAges.length; q++) {

        if (this.searchObj.infantAges[q] == "less than 1") {
          this.searchObj.infantAges[q] = "0";
        }
      }


      if (this.searchObj.adult == null) {
        this.searchObj.adult = 0;
      }
      if (this.searchObj.infant == null) {
        this.searchObj.infant = 0;
      }
      if (this.searchObj.child == null) {
        this.searchObj.child = 0;
      }


      this.searchObj.agencyID = localStorage.getItem("AgencyId");
      this.searchObj.flightLocationInfo[0].departureDate = this.formatDate(this.searchObj.flightLocationInfo[0].departureDateFront);
      this.searchObj.flightLocationInfo = JSON.parse(JSON.stringify(this.searchObj.flightLocationInfo));


      this.searchObj.journeyType = 1;

      localStorage.setItem('flightSearchData', JSON.stringify(this.searchObj));

      this.router.navigateByUrl('/flightResults');

    }
    else {
      this.messageService.add({ severity: 'error', summary: 'You do not have rights', detail: "Rights Issue" });

    }
    //else {
    //  $("#lblError1").show();
    //  document.getElementById("lblError1").style.color = "#FE2C02";
    //  document.getElementById("lblError1").innerHTML = "You don't have right to perform search."
    //  $("#lblError1").delay(5000).hide(100);
    //  return false;
    //}
      
   
  }






  formatDate(date: Date): string {
    const year = date.getFullYear();
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // months are 0-based
    return `${year}-${month}-${day}`;

  }






  parseDate(dateString: string) {
    if (dateString) {
      return dateString;
    }
    return null;
  }


  RoundtripSearchClick() {
    try {
      if (this.haveRights) {
        this.oneWayResults = false;
        this.roundTripResults = true;
        this.multicityResults = false;
        this.searchObj.agencyID = String(localStorage.getItem("AgencyId"));
        this.searchObj.parentHierarchy = localStorage.getItem("ParentHierarchy");
        let deplist = this.searchObj.flightLocationInfo[0].fromAirport.split("-");
        let start = deplist[0];
        let tolist = this.searchObj.flightLocationInfo[0].toAirport.split("-");
        let start1 = tolist[0];
        this.searchObj.flightLocationInfo[0].fromCity = start.trim();
        this.searchObj.flightLocationInfo[0].toCity = start1.trim();

        if (this.searchObj.adult == null) {
          this.searchObj.adult = 0;
        }
        if (this.searchObj.infant == null) {
          this.searchObj.infant = 0;
        }
        if (this.searchObj.child == null) {
          this.searchObj.child = 0;
        }

        for (let q = 0; q < this.searchObj.infantAges.length; q++) {

          if (this.searchObj.infantAges[q] == "less than 1") {
            this.searchObj.infantAges[q] = "0";
          }
        }
        for (let f = 0; f < this.searchObj.flightLocationInfo.length; f++) {
          for (let i = 0; i < this.airportList.length; i++) {
            if (this.searchObj.flightLocationInfo[f].fromCity.trim() == this.airportList[i].iatA_CODE) {
              this.searchObj.flightLocationInfo[f].combineAirportFrom = this.airportList[i].combineAirportFrom;
              break;
            }
          }
          for (let i = 0; i < this.airportList.length; i++) {
            if (this.searchObj.flightLocationInfo[f].toCity.trim() == this.airportList[i].iatA_CODE) {
              this.searchObj.flightLocationInfo[f].combineAirportTo = this.airportList[i].combineAirportTo;
              break;
            }
          }
        }
        this.searchObj.agencyID = localStorage.getItem("AgencyId");
        this.searchObj.flightLocationInfo[0].departureDate = this.formatDate(this.searchObj.flightLocationInfo[0].departureDateFront);
        this.searchObj.returnDate = this.formatDate(this.searchObj.returnDateFront);
        this.searchObj.flightLocationInfo = JSON.parse(JSON.stringify(this.searchObj.flightLocationInfo));


        this.searchObj.journeyType = 2;


        localStorage.setItem('flightSearchData', JSON.stringify(this.searchObj));

        this.router.navigateByUrl('/flightResults');


      }
      else {
        this.messageService.add({ severity: 'error', summary: 'You do not have rights', detail: "Rights Issue" });

      }


    }
    catch (e) {
      //console.log(e)
    }
  }

  switchairports() {

    if (this.searchObj.journeyType == 1 || this.searchObj.journeyType == 2) {
      if (this.searchObj.flightLocationInfo[0].fromAirport != undefined && this.searchObj.flightLocationInfo[0].fromAirport != null
        && this.searchObj.flightLocationInfo[0].fromAirport != "" && this.searchObj.flightLocationInfo[0].toAirport != undefined && this.searchObj.flightLocationInfo[0].toAirport != null
        && this.searchObj.flightLocationInfo[0].toAirport != "") {
        let fromair = this.searchObj.flightLocationInfo[0].fromAirport;
        let toair = this.searchObj.flightLocationInfo[0].toAirport;

       

        this.searchObj.flightLocationInfo[0].fromAirport = toair;
        this.searchObj.flightLocationInfo[0].toAirport = fromair;


      }
    }

  }













  MultiCitySearchClick() {
    try {
      if (this.haveRights) {
        for (let i = 0; i < this.searchObj.flightLocationInfo.length; i++) {
          for (let j = 0; j < this.airportList.length; j++) {
            if (this.searchObj.flightLocationInfo[i].fromCity.trim() == this.airportList[j].iatA_CODE) {
              this.searchObj.flightLocationInfo[i].combineAirportFrom = this.airportList[j].combineAirportFrom;
              break;
            }
          }
          for (let k = 0; k < this.airportList.length; k++) {
            if (this.searchObj.flightLocationInfo[i].toCity.trim() == this.airportList[k].iatA_CODE) {
              this.searchObj.flightLocationInfo[i].combineAirportTo = this.airportList[k].combineAirportTo;
              break;
            }
          }
        }

        this.oneWayResults = false;
        this.roundTripResults = false;
        this.multicityResults = true;
        this.searchObj.parentHierarchy = localStorage.getItem("ParentHierarchy");
        this.searchObj.agencyID = String(localStorage.getItem("AgencyId"));
        let deplist = this.searchObj.flightLocationInfo[0].fromAirport.split("-");
        let start = deplist[0];
        let tolist = this.searchObj.flightLocationInfo[0].toAirport.split("-");
        let start1 = tolist[0];
        this.searchObj.flightLocationInfo[0].fromCity = start.trim();
        this.searchObj.flightLocationInfo[0].toCity = start1.trim();

        if (this.searchObj.adult == null) {
          this.searchObj.adult = 0;
        }
        if (this.searchObj.infant == null) {
          this.searchObj.infant = 0;
        }
        if (this.searchObj.child == null) {
          this.searchObj.child = 0;
        }

        for (let q = 0; q < this.searchObj.infantAges.length; q++) {

          if (this.searchObj.infantAges[q] == "less than 1") {
            this.searchObj.infantAges[q] = "0";
          }
        }
        this.searchObj.agencyID = localStorage.getItem("AgencyId");
        for (let o = 0; o < this.searchObj.flightLocationInfo.length; o++) {
          this.searchObj.flightLocationInfo[o].departureDate = this.formatDate(this.searchObj.flightLocationInfo[o].departureDateFront);
        }

        this.searchObj.flightLocationInfo = JSON.parse(JSON.stringify(this.searchObj.flightLocationInfo));


        this.searchObj.journeyType = 3;


        localStorage.setItem('flightSearchData', JSON.stringify(this.searchObj));

        this.router.navigateByUrl('/flightResults');



      }
      else {
        this.messageService.add({ severity: 'error', summary: 'You do not have rights', detail: "Rights Issue" });

      }
    


    }
    catch (e) {  }
  }


  importButton() {
    //console.log(this.importPNR);
    if (this.IMPORTRights) {
      var loader = document.getElementById("loaderissue") as HTMLDivElement;
      loader.classList.remove("loaders");
      try {

        this.importPNR.importAgency = String(localStorage.getItem("AgencyId"));
        this.importPNR.parentHierarchy = localStorage.getItem("ParentHierarchy");
        this.importPNR.importUser = Number(localStorage.getItem("UserId"));
        this.flightService.importPNR(this.importPNR).subscribe((data) => {

          var loaders = document.getElementById("loaderissue") as HTMLDivElement;
          loaders.classList.add("loaders");
          if (data.isSaved) {
            var loaderf = document.getElementById("loaderissue") as HTMLDivElement;
            loaderf.classList.add("loaders");
            localStorage.setItem('importPNRID', JSON.stringify(data.bookingID));

            this.router.navigateByUrl('/importPNR');
          }
          else {
            this.messageService.add({ severity: 'error', summary: 'Try Again', detail: data.errorInfo });

          }

        });
      }



      catch (e) { }
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'You do not have rights', detail:  "Rights Issue"});

    }

  }




  getFlightSearchHistory() {
    this.flightService.getFlightSearchHistory(Number(localStorage.getItem("UserId")), String(localStorage.getItem("AgencyId"))).subscribe((data) => {
      this.searchHistoryList = data;
      for (let j = 0; j < this.searchHistoryList.length; j++) {
        this.popoverArray.push(false);
      }
    });
  }

  searchWithHistory(n: number) {

    if (this.searchHistoryList[n].tripType == "Oneway") {
      let onewayTripValue: string = "oneway";
      this.searchObj.flightLocationInfo = [];
      this.searchObj.flightLocationInfo[0] = new FlightSearchDestinationProperties();
      this.searchObj.flightLocationInfo[0].fromAirport = this.searchHistoryList[n].fromAirport;
      this.searchObj.flightLocationInfo[0].toAirport = this.searchHistoryList[n].toAirport;

      this.searchObj.returnDate = "";
      this.searchObj.days = 0;
      this.searchObj.flightLocationInfo[0].departureDateFront = new Date(this.searchHistoryList[n].departureDate);
      this.searchObj.adult = this.searchHistoryList[n].adults;
      this.searchObj.child = this.searchHistoryList[n].children;
      this.searchObj.infant = this.searchHistoryList[n].infants;
      for (let i = 0; i < this.searchHistoryList[n].children; i++) {
        const ageIndex = i % this.childAgeList.length;
        this.searchObj.childAges.push(this.childAgeList[ageIndex].childAgeItem);
      }
      if (this.searchObj.infant) {
        for (let q = 0; q < this.searchObj.infant; q++) {
          let infantAge = this.searchObj.infant.toString();
          if (infantAge === "less than 1") {
            infantAge = "0";
          }
          this.searchObj.infantAges.push(infantAge);
        }
      }
      this.passengerSelectionList[0].value = this.searchHistoryList[n].children;
      this.selectedChild = String(this.searchHistoryList[n].children);

      this.passengerSelectionListInfant[0].valueInf = this.searchHistoryList[n].infants;
      this.selectedInfant = String(this.searchHistoryList[n].infants);
      this.searchObj.cabinClass = this.searchHistoryList[n].travelClass;
      this.searchObj.fareType = this.searchHistoryList[n].fareType;
      this.selectedDiv = 1;
      this.searchObj.journeyType = 1;
     
    }

    else if (this.searchHistoryList[n].tripType == "Roundway") {
      let roundwayTripValue: string = "roundtrip";
      this.searchObj.flightLocationInfo = [];
      this.searchObj.flightLocationInfo[0] = new FlightSearchDestinationProperties();
      this.searchObj.flightLocationInfo[0].fromAirport = this.searchHistoryList[n].fromAirport;
      this.searchObj.flightLocationInfo[0].toAirport = this.searchHistoryList[n].toAirport;
      this.searchObj.flightLocationInfo[0].departureDateFront = new Date(this.searchHistoryList[n].departureDate);
      this.searchObj.returnDateFront = new Date(this.searchHistoryList[n].returnDate);

      this.searchObj.adult = this.searchHistoryList[n].adults;
      this.searchObj.child = this.searchHistoryList[n].children;
      this.passengerSelectionList[0].value = this.searchHistoryList[n].children;
      this.selectedChild = String(this.searchHistoryList[n].children);
      this.UpdateSelectedPassenger();
      this.UpdateMaxValues();

      this.searchObj.infant = this.searchHistoryList[n].infants;
      this.passengerSelectionListInfant[0].valueInf = this.searchHistoryList[n].infants;
      this.selectedInfant = String(this.searchHistoryList[n].infants);
      for (let i = 0; i < this.searchHistoryList[n].children; i++) {
        const ageIndex = i % this.childAgeList.length;
        this.searchObj.childAges.push(this.childAgeList[ageIndex].childAgeItem);
      }
      if (this.searchObj.infant) {
        for (let q = 0; q < this.searchObj.infant; q++) {
          let infantAge = this.searchObj.infant.toString();
          if (infantAge === "less than 1") {
            infantAge = "0";
          }
          this.searchObj.infantAges.push(infantAge);
        }
      }
      this.infantAgeList.push;
      this.searchObj.cabinClass = this.searchHistoryList[n].travelClass;
      this.searchObj.fareType = this.searchHistoryList[n].fareType;
      this.selectedDiv = 2;
      this.searchObj.journeyType = 2;
      this.visible = false;
      this.dialogVisible = false;
 
    }

    else if (this.searchHistoryList[n].tripType == "Multi City") {
      let multicityTripValue: string = "multicity";
      this.searchObj.returnDate = "";
      this.searchObj.days = 0;
      var fromAirportList = this.searchHistoryList[n].fromAirport.split(",");
      var toAirportList = this.searchHistoryList[n].toAirport.split(",");
      var departureDateList = this.searchHistoryList[n].departureDate.split(",");

     

      this.searchObj.flightLocationInfo = [];
      for (let a = 0; a < fromAirportList.length; a++) {
        let fsdpObj = new FlightSearchDestinationProperties();
        fsdpObj.fromAirport = fromAirportList[a].trim();
        fsdpObj.toAirport = toAirportList[a].trim();
        let rawDate = departureDateList[a] ? departureDateList[a].trim() : null;
        let parsedDate = rawDate ? new Date(rawDate) : null;
        if (parsedDate && !isNaN(parsedDate.getTime())) {
          fsdpObj.departureDateFront = parsedDate;
        } else {
          console.error("Invalid Date for Segment:", rawDate);
          fsdpObj.departureDateFront = null;
        }

        this.searchObj.flightLocationInfo.push(fsdpObj);
      }


      this.searchObj.adult = this.searchHistoryList[n].adults;
      this.searchObj.child = this.searchHistoryList[n].children;
      this.passengerSelectionList[0].value = this.searchHistoryList[n].children;
      this.selectedChild = String(this.searchHistoryList[n].children);

      this.searchObj.infant = this.searchHistoryList[n].infants;
      this.passengerSelectionListInfant[0].valueInf = this.searchHistoryList[n].infants;
      this.selectedInfant = String(this.searchHistoryList[n].infants);
      for (let i = 0; i < this.searchHistoryList[n].children; i++) {
        const ageIndex = i % this.childAgeList.length;
        this.searchObj.childAges.push(this.childAgeList[ageIndex].childAgeItem);
      }
      if (this.searchObj.infant) {
        for (let q = 0; q < this.searchObj.infant; q++) {
          let infantAge = this.searchObj.infant.toString();
          if (infantAge === "less than 1") {
            infantAge = "0";
          }
          this.searchObj.infantAges.push(infantAge);
        }
      }
      this.searchObj.cabinClass = this.searchHistoryList[n].travelClass;
      this.searchObj.fareType = this.searchHistoryList[n].fareType;

      this.selectedDiv = 3;
      this.searchObj.journeyType = 3;
    }



  }
  //searchWithHistory(n: number) {

  //  if (this.searchHistoryList[n].tripType == "Oneway") {
  //    let onewayTripValue: string = "oneway";
  //    this.searchObj.flightLocationInfo = [];
  //    this.searchObj.flightLocationInfo[0] = new FlightSearchDestinationProperties();
  //    this.searchObj.flightLocationInfo[0].fromAirport = this.searchHistoryList[n].fromAirport;
  //    this.searchObj.flightLocationInfo[0].toAirport = this.searchHistoryList[n].toAirport;

  //    this.searchObj.returnDate = "";
  //    this.searchObj.days = 0;
  //    this.searchObj.flightLocationInfo[0].departureDateFront = new Date(this.searchHistoryList[n].departureDate);
  //    this.searchObj.adult = this.searchHistoryList[n].adults;
  //    this.searchObj.child = this.searchHistoryList[n].children;
  //    this.searchObj.infant = this.searchHistoryList[n].infants;
  //    this.passengerSelectionList[0].value = this.searchHistoryList[n].children;
  //    this.selectedChild = String(this.searchHistoryList[n].children);

  //    this.passengerSelectionListInfant[0].valueInf = this.searchHistoryList[n].infants;
  //    this.selectedInfant = String(this.searchHistoryList[n].infants);
  //    this.searchObj.cabinClass = this.searchHistoryList[n].travelClass;
  //    this.searchObj.fareType = this.searchHistoryList[n].fareType;
  //    this.selectedDiv = 1;
  //    this.searchObj.journeyType = 1;
  //    console.log("Search Object for Oneway:", this.searchObj);
  //  }

  //  else if (this.searchHistoryList[n].tripType == "Roundway") {
  //    let roundwayTripValue: string = "roundtrip";
  //    this.searchObj.flightLocationInfo = [];
  //    this.searchObj.flightLocationInfo[0] = new FlightSearchDestinationProperties();
  //    this.searchObj.flightLocationInfo[0].fromAirport = this.searchHistoryList[n].fromAirport;
  //    this.searchObj.flightLocationInfo[0].toAirport = this.searchHistoryList[n].toAirport;
  //    this.searchObj.flightLocationInfo[0].departureDateFront = new Date(this.searchHistoryList[n].departureDate);
  //    //this.searchObj.returnDate = this.searchHistoryList[n].returnDate;
  //    this.searchObj.returnDateFront = new Date(this.searchHistoryList[n].returnDate);

  //    this.searchObj.adult = this.searchHistoryList[n].adults;
  //    this.searchObj.child = this.searchHistoryList[n].children;
  //    this.passengerSelectionList[0].value = this.searchHistoryList[n].children;
  //    this.selectedChild = String(this.searchHistoryList[n].children);
  //    this.UpdateSelectedPassenger();
  //    this.UpdateMaxValues();

  //    this.searchObj.infant = this.searchHistoryList[n].infants;
  //    this.passengerSelectionListInfant[0].valueInf = this.searchHistoryList[n].infants;
  //    this.selectedInfant = String(this.searchHistoryList[n].infants);
  //    //this.infantAgeList = [];
  //    this.infantAgeList.push;
  //    this.searchObj.cabinClass = this.searchHistoryList[n].travelClass;
  //    this.searchObj.fareType = this.searchHistoryList[n].fareType;
  //    this.selectedDiv = 2;
  //    this.searchObj.journeyType = 2;
  //    this.visible = false;
  //    this.dialogVisible = false;
  //    console.log(this.searchObj);
  //    console.log(this.searchHistoryList[n]);
  //  }

  //  else if (this.searchHistoryList[n].tripType == "Multi City") {
  //    let multicityTripValue: string = "multicity";
  //    this.searchObj.returnDate = "";
  //    this.searchObj.days = 0;
  //    var fromAirportList = this.searchHistoryList[n].fromAirport.split(",");
  //    var toAirportList = this.searchHistoryList[n].toAirport.split(",");
  //    var departureDateList = this.searchHistoryList[n].departureDate.split(",");

  //    console.log("Departure Dates (Raw):", departureDateList);

  //    this.searchObj.flightLocationInfo = [];
  //    for (let a = 0; a < fromAirportList.length; a++) {
  //      let fsdpObj = new FlightSearchDestinationProperties();
  //      fsdpObj.fromAirport = fromAirportList[a].trim();
  //      fsdpObj.toAirport = toAirportList[a].trim();
  //      let rawDate = departureDateList[a] ? departureDateList[a].trim() : null;
  //      let parsedDate = rawDate ? new Date(rawDate) : null;
  //      if (parsedDate && !isNaN(parsedDate.getTime())) {
  //        fsdpObj.departureDateFront = parsedDate;
  //      } else {
  //        console.error("Invalid Date for Segment:", rawDate);
  //        fsdpObj.departureDateFront = null;
  //      }

  //      this.searchObj.flightLocationInfo.push(fsdpObj);
  //    }


  //    this.searchObj.adult = this.searchHistoryList[n].adults;
  //    this.searchObj.child = this.searchHistoryList[n].children;
  //    this.passengerSelectionList[0].value = this.searchHistoryList[n].children;
  //    this.selectedChild = String(this.searchHistoryList[n].children);

  //    this.searchObj.infant = this.searchHistoryList[n].infants;
  //    this.passengerSelectionListInfant[0].valueInf = this.searchHistoryList[n].infants;
  //    this.selectedInfant = String(this.searchHistoryList[n].infants);

  //    this.searchObj.cabinClass = this.searchHistoryList[n].travelClass;
  //    this.searchObj.fareType = this.searchHistoryList[n].fareType;

  //    this.selectedDiv = 3;
  //    this.searchObj.journeyType = 3;
  //  }



  //}

  pnrCancelClick() { }
  OfflineRequest() {
    localStorage.setItem('fromOfflineRequestRoute', 'OfflineRequestList');
    this.router.navigateByUrl('/offlineRequestList');
  }
  SetReturnMinDate = (departureDate: Date): void => {
    if (departureDate != null) {
      if (typeof document !== 'undefined') {
        document.body.classList.remove('p-overflow-hidden');
        document.body.style.removeProperty('--scrollbar-width');
      }
      this.currentDateReturn = new Date(departureDate);

      if (this.selectedDiv == 2 && this.searchObj.returnDateFront) {
        if (new Date(departureDate) > new Date(this.searchObj.returnDateFront)) {
          if (this.returnDateId) {
            this.returnDateId.value = null;
          }
          this.searchObj.returnDateFront = null;
          this.searchObj.days = 0;
        } else {
          this.returndatechange();
        }
      }
      if (this.selectedDiv == 3) {
        setTimeout(() => {
          const departureDate = this.departureDateId.toArray();
          departureDate.forEach((item, id) => {
            if (id > 0 && (departureDate[id].value == "" || departureDate[id].value == undefined || departureDate[id].value == null)) {
              if (departureDate[id - 1].value == "" || departureDate[id - 1].value == undefined || departureDate[id - 1].value == null) {
                this.currentDateDepartureList[id] = this.currentDateDepartureList[id - 1];
              }
              else {
                this.currentDateDepartureList[id] = new Date(departureDate[id - 1].value);
              }
            }
            else if (id > 0 && departureDate[id].value != "" && departureDate[id].value != undefined && departureDate[id].value != null) {
              if (new Date(departureDate[0].value) > new Date(item.value)) {
                item.value = null;
                this.searchObj.flightLocationInfo[id].departureDateFront = null;
                this.currentDateDepartureList[id] = new Date(departureDate[0].value);

              }
              else if (new Date(departureDate[0].value) < new Date(item.value)) {
                this.currentDateDepartureList[id] = new Date(departureDate[id - 1].value);

              }
            }
            if (id > 0 && id < departureDate.length - 1 && departureDate[id + 1].value != "" && departureDate[id + 1].value != undefined && departureDate[id + 1].value != null) {
              if (new Date(departureDate[id].value) > new Date(departureDate[id + 1].value)) {
                departureDate[id + 1].value = null;
                this.searchObj.flightLocationInfo[id + 1].departureDateFront = null;
              }
            }


          });
        }, 0);
      }
    }
  }

  SetCurrentDate = (): void => {
    let date = new Date();
    let todayDate: any = date.getDate();
    let month: any = date.getMonth() + 1;
    let year = date.getFullYear();
    if (todayDate < 10) {
      todayDate = "0" + todayDate;
    }
    if (month < 10) {
      month = "0" + month;
    }
    this.currentDateDeparture = year + "-" + month + "-" + todayDate;
    this.currentDateReturn = new Date(this.currentDateDeparture);
  }

  offlineClick(type: number) {
    if (OfflineTypesMainEnum.Booking == type) {
      localStorage.removeItem('offlineBookingId');
      localStorage.setItem('RequestActionOffline', 'User');
      localStorage.setItem('RequestTypeOffline', 'Create');
      localStorage.setItem('RequestTypeIdFromOffline', OfflineRequestTypeEnum.OfflineBookingGroupRequest.toString());
      localStorage.setItem('fromOfflineRequestRoute', 'flightSearch');
      this.router.navigateByUrl('/offlineFlightSearch');

    }
    else if (OfflineTypesMainEnum.Ticket == type) {
      localStorage.removeItem('offlineBookingId');
      localStorage.setItem('RequestActionOffline', 'User');
      localStorage.setItem('RequestTypeIdFromOffline', OfflineRequestTypeEnum.OfflineTicketRequest.toString());
      localStorage.setItem('fromOfflineRequestRoute', 'flightSearch');
      localStorage.setItem("RequestTypeOffline", "Create");
      this.router.navigate(["/offlineTicket"]);
    }
    else if (OfflineTypesMainEnum.Resissue == type) {
      localStorage.removeItem('offlineBookingId');
      localStorage.setItem('RequestActionOffline', 'User');
      localStorage.setItem('RequestTypeIdFromOffline', OfflineRequestTypeEnum.OfflineReissueRequest.toString());
      localStorage.setItem('fromOfflineRequestRoute', 'flightSearch');
      localStorage.setItem("RequestTypeOffline", "Create");
      this.router.navigateByUrl('/offlineFlightSearch');
    }
    else if (OfflineTypesMainEnum.Refund == type) {
      localStorage.removeItem('offlineBookingId');
      localStorage.setItem('RequestActionOffline', 'User');
      localStorage.setItem('RequestTypeIdFromOffline', OfflineRequestTypeEnum.OfflineRefundRequest.toString());
      localStorage.setItem('fromOfflineRequestRoute', 'flightSearch');
      localStorage.setItem("RequestTypeOffline", "Create");
      this.router.navigate(["/offlineRefund"]);
    }
    else if (OfflineTypesMainEnum.Void == type) {
      localStorage.removeItem('offlineBookingId');
      localStorage.setItem('RequestActionOffline', 'User');
      localStorage.setItem('RequestTypeIdFromOffline', OfflineRequestTypeEnum.OfflineVoidRequest.toString());
      localStorage.setItem('fromOfflineRequestRoute', 'flightSearch');
      localStorage.setItem("RequestTypeOffline", "Create");
      this.router.navigate(["/offlineVoid"]);
    }
  }

  ngOnDestroy() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

}
